"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeScreenSectionType = void 0;
var HomeScreenSectionType;
(function (HomeScreenSectionType) {
    HomeScreenSectionType["Listings"] = "listings";
    HomeScreenSectionType["Users"] = "users";
    HomeScreenSectionType["FlashAuctions"] = "flashAuctions";
})(HomeScreenSectionType || (exports.HomeScreenSectionType = HomeScreenSectionType = {}));
